// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3edPE","newExpiryDate":"styles_newExpiryDate__1VsRT","footer":"styles_footer__2jyeL"};